import { Box } from '@mui/material'
import { getConfigOptionIconUrl, sanitizeIconFilename } from '../../utils/config-option-icons'

/**
 * Renders a configurable SVG from API config-icons with optional tint (CSS mask).
 * @param {object} props
 * @param {string | null | undefined} props.filename
 * @param {number} [props.size]
 * @param {string} [props.color]
 * @param {string} [props.alt]
 */
export function ConfigOptionIcon({
  filename,
  size = 24,
  color,
  alt = '',
}) {
  const safe = sanitizeIconFilename(filename)
  const url = getConfigOptionIconUrl(safe)
  if (!safe || !url) return null

  if (color) {
    return (
      <Box
        role="img"
        aria-label={alt || safe}
        sx={{
          width: size,
          height: size,
          flexShrink: 0,
          bgcolor: color,
          maskImage: `url("${url}")`,
          maskSize: 'contain',
          maskRepeat: 'no-repeat',
          maskPosition: 'center',
          WebkitMaskImage: `url("${url}")`,
          WebkitMaskSize: 'contain',
          WebkitMaskRepeat: 'no-repeat',
          WebkitMaskPosition: 'center',
        }}
      />
    )
  }

  return (
    <Box
      sx={{
        width: size,
        height: size,
        flexShrink: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Box
        component="img"
        src={url}
        alt={alt || safe}
        sx={{
          width: '100%',
          height: '100%',
          objectFit: 'contain',
          display: 'block',
        }}
      />
    </Box>
  )
}
